import src from "IMAGE";
export default { src, width: 273, height: 74, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABxZJX0MOklyDhkfVxcXF3wSEhJhPBMQYEMOCkJFDwpDAH5lC31tMxVyJhYRVhcXF3sXFxd6QhYSbm8XEG6EHBOBtDwNz+vo/8UAAAAASUVORK5CYII="};
